import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CostsCentersListComponent } from './costs-centers-list/costs-centers-list.component';
import { CostsCentersDetailComponent } from './costs-centers-detail/costs-centers-detail.component';

const routes: Routes = [
    {
       path: 'costsCenters',
       children: [
         { path: '', component: CostsCentersListComponent },
         { path: ':id', component: CostsCentersDetailComponent }
       ]
     }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CostsCentersRoutingModule { }
